export default __webpack_public_path__ + "static/media/relatorio_subitens.8b5aeb66.png";